module.exports = __webpack_public_path__ + "static/media/ringNew.7d380d81.wav";